import { useEffect, useState, useMemo } from 'react';
import styled from 'styled-components';
import normalize from 'normalize-strings';
import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy'
import { useNavigate } from 'react-router-dom';
import Button from '../StoraEnsoComponents/Button';
import Icon from '../StoraEnsoComponents/Icon';
import Map from './Map';
import MediaModal from './MediaModal';
import { getProjectsOverview } from '../../services/mapService';
import MediaGrid from './MediaGrid';
// import SearchProjectInput from './SearchProjectInput';
import DefaultLoading from '../Loading';
import { SidebarWrapper, Sidebar }  from '../Sidebar';
import DataFilter from './DataFilter';
import { ReactComponent as ArrowUpSvg } from '../../assets/icons/angle-up.svg';

const OpenIcon = styled(ArrowUpSvg)``;

const OpenPanelBtn = styled(Button)`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
`;

const CloseIcon = styled(Icon)`
  cursor: pointer;
  align-self: flex-end;
`;

const Loading = styled(DefaultLoading)`
  margin: 60px auto;
  justify-content: center;
`;

const MapWrapper = styled.div`
  height: calc(100vh - 80px);
  overflow-y: hidden;
  /* font-size: 1rem; */
  position: relative;

  .ol-overlaycontainer-stopevent {
    position: absolute;
    width: 100% !important;
    height: 100% !important;
    margin: 0;
  }

  .ol-scale-line {
    position: absolute;
    right: 8px;
    bottom: 8px;

    .ol-scale-line-inner {
      position: absolute !important;
      bottom: 0 !important;
      right: 0 !important;
    }
  }

  .ol-mouse-position {
    position: absolute !important;
    top: 58px !important;
    right: 8px !important;
  }

  .cfm-geolocation {
    position: absolute !important;
    right: 8px !important;
    top: calc(50% + 14px) !important;
    transform: translateY(-50%) !important;
  }

  .ol-zoom {
    position: absolute !important;
    right: 8px !important;
    top: calc(50% + 1.5rem + 2.5rem) !important;
    transform: translateY(-50%) !important;
  }
`;

const GridWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px;
`;

const PanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
`;

// TODO
// - handle loading error/progress
// - show map loading icon
// - remove !important from styles
function MediaMap() {
  const [visible, setVisible] = useState(true);
  const [overviewData, setOverviewData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [zoomedItemId, setZoomedItemId] = useState(null);
  const [filtered, setFiltered] = useState(null);
  const [gridSearch, setGridSearch] = useState('');
  const [gridTypeFilter, setGridTypeFilter] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const navigate = useNavigate();

  const gridData = useMemo(() => {
    if (overviewData) {
        const data = filtered || overviewData;
        return data.map(item => ({
          ...item.properties,
          hasGeometry: !!item.geometry,
        }));
    } else {
        return [];
    }
  }, [overviewData, filtered]);

  const mapData = useMemo(() => {
    if (overviewData) {
        const data = filtered || overviewData;
        return data.filter(el => el.geometry);
    } else {
        return null;
    }
  }, [overviewData, filtered]);

  useEffect(() => {
    const activeTypes = keys(pickBy(gridTypeFilter, value => value === true));

    if(!isLoading && (gridSearch.trim().length > 0 || (gridTypeFilter && activeTypes.length !== 5))) {
      const regex = new RegExp(normalize(gridSearch), 'gi');
      let tempData = overviewData;

      if(activeTypes.length === 0) {
        setFiltered(null);
      }

      if(activeTypes.length !== 5) {
        // handle new forest types (forest, forestMulti, forestRGB)
        const processedActiveTypes = activeTypes.includes('forest') ? [...activeTypes, 'forestMulti', 'forestRGB'] : activeTypes;
        tempData = overviewData.filter(item => processedActiveTypes.includes(item.properties.type));
      }

      setFiltered(tempData.filter(item => ((normalize(item.properties?.name || '')).match(regex) || (normalize(item.properties?.location || '')).match(regex))));
    } else {
      setFiltered(null);
    }
  }, [isLoading, gridSearch, gridTypeFilter]);

  const handleSelection = data => {
    data.length > 1 ? setSelectedItems(data) : navigate(`/project/detail/${data[0].id}`);
  }

  useEffect(() => {
    getProjectsOverview()
      .then(data => {
        setOverviewData(data);
      })
      .catch(() => {
        console.error('Cannot download media data.')
      })
      .then(() => setLoading(false))
  }, []);

  if(isLoading) {
    return (
      <Loading message="Loading map data..." />
    )
  }

  return (
    <SidebarWrapper>
      <Sidebar
        direction="bottom"
        visible={visible}
      >
        <GridWrapper>
          <PanelWrapper>
            <div>
              <CloseIcon role="button" onClick={() => setVisible(false)}>close</CloseIcon>
            </div>
          </PanelWrapper>
          <MediaGrid
            loading={false}
            data={gridData}
            onItemSelect={selectedId => handleSelection([{id: selectedId}])}
            onItemZoom={selectedId => setZoomedItemId(selectedId)}
            />
        </GridWrapper>
      </Sidebar>
      <MapWrapper>
        <DataFilter
          onSearchChange={value => setGridSearch(value)}
          onTypeChange={value => setGridTypeFilter(value)}
        />
        <MediaModal items={selectedItems} />
        {/* <SearchProjectInput data={mapData} onSearch={data => setFiltered(data)} onSelect={selectedId => handleSelection([{id: selectedId}])} /> */}
        <Map mapData={mapData} zoomedItemId={zoomedItemId} onSelectedMedia={handleSelection} />
        <OpenPanelBtn icon={<OpenIcon />} onClick={() => setVisible(true)}>Find your project</OpenPanelBtn>
      </MapWrapper>
    </SidebarWrapper>
  );
}
export default MediaMap;